import { createListenerMiddleware, addListener } from '@reduxjs/toolkit';

import type { StoreState, AppDispatch } from './types';

export const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening.withTypes<
  StoreState,
  AppDispatch,
  void
>();

export const addAppListener = addListener.withTypes<StoreState, AppDispatch>();
